/**
 * Toast notification store — Zustand-based with auto-removal.
 * UI component (Radix Toast) subscribes to this store in Phase 2.
 */

import { create } from 'zustand'

export type ToastType = 'success' | 'error' | 'info' | 'warning'

export interface ToastMessage {
  id: string
  type: ToastType
  title: string
  description?: string
  durationMs: number
}

interface ToastState {
  messages: ToastMessage[]
  push: (msg: Omit<ToastMessage, 'id'>) => void
  remove: (id: string) => void
}

let counter = 0

export const useToastStore = create<ToastState>((set) => ({
  messages: [],

  push: (msg) => {
    const id = `toast-${++counter}-${Date.now()}`
    const toast: ToastMessage = { ...msg, id }

    set((state) => ({ messages: [...state.messages, toast] }))

    // Auto-remove after duration
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        set((state) => ({
          messages: state.messages.filter((m) => m.id !== id),
        }))
      }, msg.durationMs)
    }
  },

  remove: (id) => {
    set((state) => ({
      messages: state.messages.filter((m) => m.id !== id),
    }))
  },
}))
